var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"page-not-found"},[_c('div',[_c('span',{staticClass:"display-3 white--text font-weight-regular"},[_vm._v("Страница не найдена")])])])}
var staticRenderFns = []

export { render, staticRenderFns }